module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("外管工作台")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("出勤风险跟进")])], 1)], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "filter-bar"
  }, [_c('span', {
    staticClass: "toolbar-label"
  }, [_vm._v("外教运营")]), _vm._v(" "), _c('adviser-select', {
    on: {
      "on-change": _vm.onAdviserChange
    },
    model: {
      value: (_vm.adviserId),
      callback: function($$v) {
        _vm.adviserId = $$v
      },
      expression: "adviserId"
    }
  }), _vm._v(" "), _c('Button-group', [_c('Button', {
    attrs: {
      "type": _vm.dateMode === 'yesterday' ? 'primary' : 'ghost'
    },
    on: {
      "click": function($event) {
        return _vm.changeDateMode('yesterday')
      }
    }
  }, [_vm._v("\n        昨日（" + _vm._s(_vm.yesterdayStr.slice(5)) + "）\n      ")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": _vm.dateMode === 'today' ? 'primary' : 'ghost'
    },
    on: {
      "click": function($event) {
        return _vm.changeDateMode('today')
      }
    }
  }, [_vm._v("今日")])], 1), _vm._v(" "), _c('Date-picker', {
    staticClass: "date-picker",
    class: {
      'is-active': _vm.dateMode === 'custom'
    },
    attrs: {
      "type": "date",
      "value": _vm.customDate,
      "placeholder": "自选日期",
      "clearable": false,
      "transfer": ""
    },
    on: {
      "on-change": _vm.onCustomDate
    }
  }), _vm._v(" "), _c('Button-group', _vm._l((_vm.statusTabs), function(item) {
    return _c('Button', {
      key: item.value,
      attrs: {
        "type": _vm.status === item.value ? 'primary' : 'ghost'
      },
      on: {
        "click": function($event) {
          return _vm.changeStatus(item.value)
        }
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-bar"
  }, [_c('Button-group', _vm._l((_vm.typeTabs), function(item) {
    return _c('Button', {
      key: item.value,
      attrs: {
        "type": _vm.typeKey === item.value ? 'primary' : 'ghost'
      },
      on: {
        "click": function($event) {
          return _vm.changeType(item.value)
        }
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1), _vm._v(" "), _c('Input', {
    staticClass: "keyword",
    attrs: {
      "placeholder": "搜索老师姓名 / ID",
      "clearable": ""
    },
    on: {
      "on-enter": _vm.search,
      "on-clear": _vm.search
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  }, [_c('Button', {
    attrs: {
      "slot": "append",
      "icon": "search"
    },
    on: {
      "click": _vm.search
    },
    slot: "append"
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "toolbar-spacer"
  }), _vm._v(" "), _c('Button', {
    on: {
      "click": _vm.exportCsv
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('Button', {
    on: {
      "click": _vm.openManual
    }
  }, [_vm._v("手动登记")]), _vm._v(" "), (_vm.pendingList.length) ? _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.openBatch
    }
  }, [_vm._v("批量跟进当前 " + _vm._s(_vm.pendingList.length) + " 节")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "stat-bar"
  }, [_c('span', {
    staticClass: "stat-date"
  }, [_vm._v(_vm._s(_vm.queryDate))]), _vm._v(" "), _vm._l((_vm.typeDict), function(item, code) {
    return _c('Tag', {
      key: code,
      attrs: {
        "color": item.color
      }
    }, [_vm._v(_vm._s(item.text) + " " + _vm._s(_vm.typeCounts[code] || 0))])
  }), _vm._v(" "), _c('span', {
    staticClass: "muted"
  }, [_vm._v("当前 " + _vm._s(_vm.groups.length) + " 位老师 · " + _vm._s(_vm.pendingLessons) + " 节课待跟进")])], 2), _vm._v(" "), (_vm.searchLoading) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.groups.length && !_vm.searchLoading) ? _c('div', {
    staticClass: "empty-card"
  }, [_c('div', {
    staticClass: "empty-big"
  }, [_vm._v("当日无需跟进的老师")]), _vm._v(" "), _c('div', {
    staticClass: "muted"
  }, [_vm._v("当天有请假单、旷课课节的老师会出现在这里，供外管逐人跟进")])]) : _c('div', {
    staticClass: "follow-list"
  }, _vm._l((_vm.groups), function(g) {
    return _c('div', {
      key: g.tchId,
      staticClass: "tch-card"
    }, [_c('div', {
      staticClass: "tch-card-head"
    }, [_c('span', {
      staticClass: "avatar",
      class: g.absentCount ? 'is-danger' : 'is-warning'
    }, [_vm._v(_vm._s(_vm.initials(g)))]), _vm._v(" "), _c('div', {
      staticClass: "tch-card-name"
    }, [_c('span', {
      staticClass: "tch-name-row"
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.openTchInfo(g.tchId)
        }
      }
    }, [_vm._v(_vm._s(_vm.tchLabel(g)))]), _vm._v(" "), (_vm.scoreText(g)) ? _c('span', {
      staticClass: "tch-score-badge"
    }, [_vm._v(_vm._s(_vm.scoreText(g)))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "muted"
    }, [_vm._v("ID " + _vm._s(g.tchId)), (g.country) ? _c('span', [_vm._v(" · " + _vm._s(g.country))]) : _vm._e(), _vm._v(" · " + _vm._s(g.studyAdviserName || '未分配'))])]), _vm._v(" "), _c('div', {
      staticClass: "tch-card-tags"
    }, [(g.absentCount) ? _c('Tag', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v("旷课 " + _vm._s(g.absentCount) + " 节")]) : _vm._e(), _vm._v(" "), (g.leaveCount) ? _c('Tag', {
      attrs: {
        "color": "yellow"
      }
    }, [_vm._v("请假 " + _vm._s(g.leaveCount) + " 条")]) : _vm._e(), _vm._v(" "), (g.lateCount) ? _c('Tag', {
      attrs: {
        "color": "blue"
      }
    }, [_vm._v("迟到 " + _vm._s(g.lateCount) + " 节")]) : _vm._e(), _vm._v(" "), (g.pendingCount) ? _c('Tag', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(g.pendingCount) + " 节待跟进")]) : _c('Tag', {
      attrs: {
        "color": "green"
      }
    }, [_vm._v("已全部跟进")])], 1), _vm._v(" "), (g.cleanDays != null) ? _c('span', {
      staticClass: "clean-days"
    }, [_vm._v("连续无异常 " + _vm._s(g.cleanDays) + " 天")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "toolbar-spacer"
    }), _vm._v(" "), _c('span', {
      staticClass: "muted"
    }, [_vm._v("共 " + _vm._s(g.total || (g.lessons || []).length) + " 节")]), _vm._v(" "), _c('Button', {
      attrs: {
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.openTchInfo(g.tchId)
        }
      }
    }, [_vm._v("档案")])], 1), _vm._v(" "), _c('div', {
      staticClass: "tch-card-body"
    }, _vm._l((g.lessons), function(l) {
      return _c('div', {
        key: _vm.lessonRowKey(l),
        staticClass: "lesson-row"
      }, [_c('span', {
        staticClass: "lesson-bar",
        class: _vm.isAbsentType(l.type) ? 'is-danger' : 'is-warning'
      }), _vm._v(" "), _c('div', {
        staticClass: "lesson-main"
      }, [_c('div', {
        staticClass: "lesson-title"
      }, [(!l.manual) ? _c('b', [_vm._v(_vm._s(l.beginTime || '—'))]) : _vm._e(), _vm._v(" "), _c('Tag', {
        attrs: {
          "color": _vm.typeColor(l.type)
        }
      }, [_vm._v(_vm._s(_vm.typeText(l.type)))]), _vm._v(" "), (l.handled) ? _c('Tag', {
        attrs: {
          "color": "green"
        }
      }, [_vm._v("已跟进")]) : _c('Tag', {
        attrs: {
          "color": "red"
        }
      }, [_vm._v("待跟进")])], 1), _vm._v(" "), (l.manual) ? _c('div', {
        staticClass: "muted"
      }, [_vm._v("手动 · 无学生")]) : _c('div', {
        staticClass: "muted"
      }, [(l.type === 'LEAVE') ? [_vm._v("请假单 " + _vm._s(l.lessonId) + " · 原因：" + _vm._s(l.reason || '未填写'))] : [_vm._v("课节 " + _vm._s(l.lessonId) + " · 学员 " + _vm._s(l.studentName || l.uid || '—') + " · 原因：" + _vm._s(l.reason || '未填写'))]], 2), _vm._v(" "), (l.handled) ? _c('div', {
        staticClass: "lesson-handled"
      }, [_vm._v("\n            跟进结果：" + _vm._s(_vm.resultText(l.result))), (l.note) ? _c('span', [_vm._v(" · " + _vm._s(l.note))]) : _vm._e(), _vm._v("\n            · " + _vm._s(l.handledBy || '') + " " + _vm._s(l.handledAt || '') + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('Button', {
        attrs: {
          "size": "small",
          "type": l.handled ? 'ghost' : 'primary'
        },
        on: {
          "click": function($event) {
            return _vm.openSingle(g, l)
          }
        }
      }, [_vm._v("\n          " + _vm._s(l.handled ? '改判' : '跟进') + "\n        ")])], 1)
    }), 0)])
  }), 0), _vm._v(" "), _c('followup-handle-modal', {
    attrs: {
      "value": _vm.showHandle,
      "lessons": _vm.handleLessons
    },
    on: {
      "on-close": function($event) {
        _vm.showHandle = false
      },
      "on-success": _vm.search
    }
  }), _vm._v(" "), _c('followup-manual-modal', {
    attrs: {
      "value": _vm.showManual,
      "default-date": _vm.queryDate
    },
    on: {
      "on-close": function($event) {
        _vm.showManual = false
      },
      "on-success": _vm.search
    }
  }), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchInfoId
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rule-bar"
  }, [_c('span', {
    staticClass: "rule-dot"
  }), _vm._v("\n    跟进口径：当天有 "), _c('b', [_vm._v("请假单")]), _vm._v("（一条请假记录一条跟进，含无约课）或 "), _c('b', [_vm._v("旷课")]), _vm._v("（含旷课·失联）课节的老师进入本板块，由外管核实并登记跟进结果；迟到只在类型选「迟到 / 全部」时出现。\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cbc4114","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrWorkbench/HrWorkbenchFollowup.vue
// module id = 1707
// module chunks = 8